import { Container } from "@mui/material";
import React, { useEffect } from "react";

import { useStepState } from "../contexts/steps/Reducer";
import { useEventService } from "../services/event-service/EventServiceContext";
import OverviewScreen from "./screens/0-overview/OverviewScreen";
import ConfigurationScreen from "./screens/1-configuration/ConfigurationScreen";
import SummaryScreen from "./screens/2-summary/SummaryScreen";
import ConfirmationScreen from "./screens/3-confirmation/ConfirmationScreen";

/**
 * Main container displaying different screens depending on the internal app state.
 */
const AppContainer = () => {
    const { step } = useStepState();
    const eventService = useEventService();

    useEffect(() => {
        eventService.sendScrollToTopEvent();
    }, [step]);

    function renderStep(step: number) {
        switch (step) {
            case 0:
                return <OverviewScreen />;
            case 1:
                return <ConfigurationScreen />;
            case 2:
                return <SummaryScreen />;
            case 3:
                return <ConfirmationScreen />;
            default:
                console.error("This step does not exist.");
        }
    }

    return (
        <Container maxWidth={false} disableGutters>
            {renderStep(step)}
        </Container>
    );
};

export default AppContainer;
